function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import { GridItem, MenuItem, TextButton, TextField, WithInfoIcon } from 'seagull';
import styles from "./IntroMessage.module.scss";
import { isCustomMessageType, orderedTemplateTypesForDropdown, templateTypeToDropdownLabel, useEditIntroMessage } from "./IntroMessage.utils";
import { Controller, useForm } from 'react-hook-form';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import { richTextValidation } from 'validators';
import { useStoreActions } from "../../../store/store-context";
export default function IntroMessage(props) {
  const {
    initialTemplateContent,
    onMessageChange
  } = props;
  const {
    getTemplateTypeByMessage,
    templateTypeToContent
  } = useEditIntroMessage();
  const {
    logBI
  } = useStoreActions();
  const defaultValues = {
    type: getTemplateTypeByMessage(initialTemplateContent),
    message: initialTemplateContent
  };
  const [customMessage, setCustomMessage] = useState(isCustomMessageType(defaultValues.type) ? initialTemplateContent : '');
  const {
    control,
    setValue,
    getValues
  } = useForm({
    mode: 'all',
    defaultValues
  });
  const [showTemplateMessage, setShowTemplateMessage] = useState(false);

  const onTypeChange = newType => {
    logBI(10491, {
      templateType: newType
    });
    const newMessage = isCustomMessageType(newType) ? customMessage : templateTypeToContent[newType];
    if (isCustomMessageType(newType)) setShowTemplateMessage(true);
    setValues({
      newType,
      newMessage
    });
  };

  const onEditMessage = newMessage => {
    const newType = getTemplateTypeByMessage(newMessage);
    if (isCustomMessageType(newType)) setCustomMessage(newMessage);
    setValues({
      newType,
      newMessage
    });
  };

  const setValues = _ref => {
    let {
      newType,
      newMessage
    } = _ref;
    const [type, message] = getValues(['type', 'message']);

    if (newMessage !== type) {
      setValue('type', newType);
    }

    if (newMessage !== message) {
      onMessageChange(newMessage);
      setValue('message', newMessage);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GridItem, {
    span: 12,
    className: styles.firstRow,
    "data-testid": "intro-message"
  }, /*#__PURE__*/React.createElement(WithInfoIcon, {
    className: styles.inputContainer,
    info: "This message will show as an introductory message on the agreement and the email your client receives. You can configure the default messages in your business settings."
  }, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "type",
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({}, connectControllerToTextField(renderProps), {
      onChange: e => {
        onTypeChange(e.target.value);
        renderProps.field.onChange(e);
      },
      "data-testid": "template-type-dropdown",
      label: "Introductory message",
      className: styles.typeInput,
      select: true
    }), orderedTemplateTypesForDropdown.map(templateType => /*#__PURE__*/React.createElement(MenuItem, {
      key: templateType,
      value: templateType,
      "data-testid": "template-type-".concat(templateType)
    }, templateTypeToDropdownLabel[templateType])))
  })), /*#__PURE__*/React.createElement(TextButton, {
    "data-testid": "edit-message",
    onClick: () => {
      logBI(10490);
      setShowTemplateMessage(true);
    },
    style: {
      visibility: showTemplateMessage ? 'hidden' : 'visible'
    }
  }, "Edit message")), showTemplateMessage && /*#__PURE__*/React.createElement(GridItem, {
    span: 12
  }, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "message",
    rules: richTextValidation(),
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({}, connectControllerToTextField(renderProps), {
      onChange: e => {
        onEditMessage(e.target.value);
        renderProps.field.onChange(e);
      },
      "data-testid": "template-content",
      placeholder: "Your message\u2026",
      multiline: true,
      minRows: 9,
      maxRows: 9
    }))
  })));
}